var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import useSWR from 'swr';
import useAccessToken from './useAccessToken';
import { createCustomer, getCustomer, patchCustomer } from '../api/wrassets/apiClient';
export default function useCustomer() {
    const { accessToken } = useAccessToken();
    const fetcher = () => __awaiter(this, void 0, void 0, function* () {
        const cachedCustomer = localStorage.getItem('customer');
        const cacheTimestamp = localStorage.getItem('customer-timestamp');
        // Use cached data if it's less than 1 hour old
        if (cachedCustomer && cacheTimestamp && Date.now() - parseInt(cacheTimestamp) < 60 * 1000) {
            return JSON.parse(cachedCustomer);
        }
        const data = yield getCustomer(accessToken);
        localStorage.setItem('customer', JSON.stringify(data));
        localStorage.setItem('customer-timestamp', Date.now().toString());
        return data;
    });
    const customer = useSWR(accessToken ? 'customer' : null, fetcher, {
        dedupingInterval: 60 * 1000, // Cache for 1 minute
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        errorRetryCount: 3,
    });
    const updateCustomer = (data) => __awaiter(this, void 0, void 0, function* () {
        yield patchCustomer(Object.assign(Object.assign({ accessToken: accessToken }, data), { data }));
        // Update SWR cache and localStorage
        const datas = yield getCustomer(accessToken);
        localStorage.setItem('customer', JSON.stringify(data));
        localStorage.setItem('customer-timestamp', Date.now().toString());
        window.location.reload();
        return datas;
    });
    const addCustomer = (data) => __awaiter(this, void 0, void 0, function* () {
        const newCustomer = yield createCustomer({
            accessToken: accessToken,
            data: Object.assign(Object.assign({}, data), { customerCreation: new Date().toISOString(), permissions: {
                    maxBoats: 10,
                    maxUsers: 20,
                    maxApi: 0,
                    maxMaintenanceRecords: 100,
                    maxLocations: 3,
                    maxBookings: 100,
                    banned: false,
                    maxBookingLeadTime: 0,
                    transactionFee: 0.06,
                    interchangeFee: 0.025,
                    listingApprovalRequired: false,
                    tier: 'Free',
                    applicationPermissions: [
                        "view_reports",
                        "inventory_access",
                        "text_templates_access",
                        "text_templates_add",
                        "text_templates_edit",
                        "text_templates_delete",
                        "email_templates_add",
                        "email_templates_edit",
                        "email_templates_delete",
                        "email_templates_access",
                        "inventory_add",
                        "inventory_delete",
                        "inventory_edit_pricing",
                        "bookings_access",
                        "campaigns_access",
                        "bookings_manual_payment",
                        "bookings_edit",
                        "bookings_delete",
                        "bookings_force",
                        "bookings_checkinout",
                        "bookings_download",
                        "bookings_deposit",
                        "bookings_revoke",
                        "bookings_collect_extra",
                        "bookings_refund",
                        "calendar_access",
                        "customers_access",
                        "customers_send_email",
                        "customers_flag_user",
                        "customers_ban_user",
                        "maintenance_access",
                        "maintenance_add_record",
                        "maintenance_delete_record",
                        "promo_access",
                        "promo_delete",
                        "promo_create",
                        "integration_access",
                        "stores_access",
                        "stores_add",
                        "stores_edit",
                        "stores_delete",
                        "stores_view_settings",
                        "stores_view_stripe_connect",
                        "manage_website_access",
                        "business_access",
                        "manual_booking_access",
                        "subscription_access",
                        "subscription_edit",
                        "users_access",
                        "users_add",
                        "users_edit",
                        "users_delete",
                        "users_view_settings",
                        "matrix_access",
                        "boatBrigade_access",
                        "capital_access",
                        "carbon_access",
                        "weather_access",
                        "affiliates_access",
                        "affiliates_add",
                        "affiliates_delete",
                        "affiliates_edit"
                    ],
                } }),
        });
        // Update localStorage
        localStorage.setItem('customer', JSON.stringify(newCustomer));
        localStorage.setItem('customer-timestamp', Date.now().toString());
        window.location.reload();
        return newCustomer;
    });
    return Object.assign(Object.assign({}, customer), { updateCustomer, addCustomer });
}
